<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';

  export let data: any;

  const { encodedContextPath } = getAppConfig();
</script>

<div class="category-container" style={data.backgroundColor ? 'background:' + data.backgroundColor : '#FFFFFF'}>
  <a href={encodedContextPath + (data?.algoliaUrl ? data.algoliaUrl : data.url)}>
    <div class="product-category-container">
      <img src={`${data.iconUrl}?fmt=auto&h=64`} alt={data.linkName} />
      <h3>{data.linkName}</h3>
    </div>
  </a>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .category-container {
    background: $primary-white;
    border-radius: 12px;
    border: solid $secondary-gray-02 1px;
    &:hover {
      border: 1px solid $tertiary-blue-02;
    }
  }
  .product-category-container {
    cursor: pointer;
    display: flex;
    width: 147px;
    padding: 12px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1;
    height: 116px;
    @include desktop-min-width {
      width: 180px;
      height: 119px;
    }
    img {
      height: 64px;
      aspect-ratio: auto;
      object-fit: contain;
    }
    h3 {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      color: $neutral-dark-01;
      text-align: center;
      @include desktop-min-width {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
</style>
